import React, {FC, PropsWithChildren} from 'react';
import styled, {css} from 'styled-components';

import {markFullStorySensitive} from '../../../helpers/fullstoryHelpers';
import {addCellsCommonStyles, compactCellBaseHeight, makeCellClassName} from './cellBaseCommon';

/*
 * Props.
 */

interface CompactCellBaseProps {
  className?: string;
  isSelected?: boolean;
  isLast?: boolean;
  isFirst?: boolean;
}

/*
 * Style.
 */

interface GridStyleProps {
  $isLast?: boolean;
  $isFirst?: boolean;
}

const StyledCellBaseGridDiv = styled.div<GridStyleProps>`
  position: relative;
  height: ${compactCellBaseHeight};

  display: grid;
  align-items: center;
  margin-bottom: 2px;
  margin-left: 14px;
  margin-right: 7px;
  padding-left: 13px;
  padding-right: 10px;
  grid-template-columns: minmax(min(20%, 90px), 24%) 16px 1fr 6px auto;
  grid-template-areas: 'first . second . third';

  ${(p) => addAdditionalStyles(p)}
`;

function addAdditionalStyles(props: GridStyleProps) {
  return css`
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    ${props.$isLast &&
    css`
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    `}
    ${props.$isFirst &&
    css`
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
    `}
  ${addCellsCommonStyles(true)}
  `;
}

/*
 * Component.
 */

export const CompactCellBase: FC<PropsWithChildren<CompactCellBaseProps>> = (props) => {
  // We need a custom class when selected to help style the next item.
  const {className: baseClassName, isSelected, children, isLast, isFirst} = props;

  const className = makeCellClassName(baseClassName, isSelected);

  return (
    <StyledCellBaseGridDiv $isFirst={isFirst} $isLast={isLast} className={markFullStorySensitive(className)}>
      {children}
    </StyledCellBaseGridDiv>
  );
};
